export default (function (value) {
  return typeof Map !== 'undefined' && value instanceof Map;
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-blueprint/~/redux-actions/es/utils/isMap.js
// module id = 253
// module chunks = 1